export default __webpack_public_path__ + "static/media/carousel-1.a0394da7.jpg";